import Axios from "axios";
const baseURL = process.env.BARRAMUNDI;
const baseURLci = process.env.CI_APPS;

export default {
    getSoapDetails(soapId, encoded = true) {
        return Axios.get(`${baseURL}record/medical-note-details/${soapId}`, {
            params: { encoded: encoded }
        }).then(res => {
            if (res.data && res.data.response) {
                return res.data.response;
            }
            return [];
        });
    },
    getSoapRecords(patientId, params) {
        return Axios.get(`${baseURL}record/history/${patientId}`, {
            params
        }).then(res => {
            if (res.data && res.data.response) {
                return res.data.response;
            }
            return [];
        });
    },
    getHistoryCountSoap(soapId) {
        return Axios.get(`${baseURL}record/history-count/soap/${soapId}`).then(
            res => {
                if (res.data && res.data.response) {
                    return res.data.response;
                }
                return [];
            }
        );
    },
    getSoapXmlContent(soapId) {
        return Axios.get(
            `${baseURL}record/medical-note-details/xml-content/${soapId}`
        ).then(res => {
            if (res.data && res.data.response) {
                return res.data.response;
            }
            return [];
        });
    },
    getDeleteDetailsSoap(soapId) {
        return Axios.get(
            `${baseURL}record/pre-delete-medical-note/${soapId}`
        ).then(res => {
            if (res.data && res.data.response) {
                return res.data.response;
            }
            return [];
        });
    },
    deleteSoapProfile(soapId) {
        return Axios.delete(`${baseURL}record/medical-note/${soapId}`).then(
            res => {
                if (res.data && res.data.response) {
                    return res.data.response;
                }
                return [];
            }
        );
    },
    lockSoapProfile(soapId) {
        return Axios.post(`${baseURL}record/medical-note-lock/${soapId}`).then(
            res => {
                if (res.data && res.data.response) {
                    return res.data.response;
                }
                return [];
            }
        );
    },
    checkProviderIsUpdated(soapId, params) {
        return Axios.post(
            `${baseURL}record/medical-note-preupdate/${soapId}`,
            params
        ).then(res => {
            if (res.data && res.data.response) {
                return res.data.response;
            }
            return null;
        });
    },
    saveEditSoapProfile(soapId, params) {
        return Axios.put(
            `${baseURL}record/medical-note/${soapId}`,
            params
        ).then(res => {
            if (res.data && res.data.response) {
                return res.data.response;
            }
            return null;
        });
    },
    /**
     *
     * @param {*} soapId
     * @param {Object} params For export soap
     * params :
     * export_type : 1:email, 3: PDF
     * dialog: true (to get the list to export) | false to submit and generate PDF/email
     * veterinarian (on submit) : String : (ex: 074c8e6b-ae65-11)
     * elements (on submit) : Array : [cb_include_all] => on,[cb_medical_note] => on,[cb_medical_record] => on
     * mr_elements (on submit) : Array : [cb_mr_14] => on
     * @returns
     */
    postSoapExport(soapId, params) {
        return Axios.post(
            `${baseURL}record/medical-note-export/${soapId}`,
            params
        ).then(res => {
            if (res.data && res.data.response) {
                return res.data.response;
            }
            return null;
        });
    },
    /**
     *
     * @param {*} soapId
     * @param {Object} params For export soap
     * params :
     * recipients - In array of array of key and recipientId (Ex: ["actor","{{actor_id}}"])
     * @returns
     */
    postSoapEmailContent(soapId, params) {
        return Axios.post(
            `${baseURL}record/medical-note-email-content/${soapId}`,
            params
        ).then(res => {
            if (res.data && res.data.response) {
                return res.data.response;
            }
            return null;
        });
    },
    /**
     *
     * @param {*} soapId
     * @param {Object} params For export soap
     * params :
     * to : {Array} - In array of array of key and recipientId (Ex: ["actor","{{actor_id}}"])
     * export_type: {String|Integer} "1",
     * timestamp: {String|Integer} - now in timestamp
     * email_type: {String|Integer} - "12"
     * veterinarian : {String} - veterinarianId
     * subject : {String}
     * message : {String}
     * elements : {Object} ex: "cb_include_all": "on"
     * mr_elements : {object} Ex: "cb_mr_6": "on"
}
     * @returns
     */
    postSoapSendEmail(soapId, params) {
        return Axios.post(
            `${baseURL}record/medical-note-send-email/${soapId}`,
            params
        ).then(res => {
            if (res.data && res.data.response) {
                return res.data.response;
            }
            return null;
        });
    },
    async soapFieldSave(soapId, params) {
        let res = await Axios.post(
            `${process.env.BARRAMUNDI}record/medical-note-savefield/${soapId}`,
            params
        );
        if (res.data && res.data.response) {
            return res.data.response;
        } else {
            return null;
        }
    },
    async getSoapDiagnosis(patientId, params) {
        return await Axios.get(`${baseURL}record/diagnosis/${patientId}`, {
            params
        }).then(res => {
            if (res.data && res.data.response) {
                return res.data.response;
            }
            return [];
        });
    },
    /**
     * @method addSectionSnippet
     * @description For the list of sections in "Add To" field in the Add Snippet modal soap
     * @param {String} soapId
     * @returns
     */
    async addSectionSnippet(soapId) {
        return await Axios.get(
            `${baseURL}record/medical-note-add-snippet/addTo-list/${soapId}`
        ).then(res => {
            if (res.data && res.data.response && res.data.response) {
                return res.data.response;
            }
            return null;
        });
    },
    async duplicateSoap(soapId, params) {
        let res = await Axios.post(
            `${process.env.BARRAMUNDI}record/medical-note-duplicate-save/${soapId}`,
            params
        );
        if (res && res.data && res.data.response) {
            return res.data.response;
        } else {
            return null;
        }
    },
    async getAmendments(soapId, params) {
        return await Axios.get(
            `${baseURL}record/medical-note-amendment-list/${soapId}`,
            {
                params
            }
        ).then(res => {
            if (res.data && res.data.response) {
                return res.data.response;
            }
            return [];
        });
    },
    getAmendmentsCountSoap(soapId) {
        return Axios.get(
            `${baseURL}record/medical-note-count-amendment/${soapId}`
        ).then(res => {
            if (res.data && res.data.response) {
                return res.data.response;
            }
            return [];
        });
    },
    deleteAmendment(soapId) {
        return Axios.delete(
            `${baseURL}record/medical-note-delete-amendment/${soapId}`
        ).then(res => {
            if (res.data && res.data.response) {
                return res.data.response;
            }
            return [];
        });
    },
    saveAmendment(params) {
        return Axios.post(
            `${baseURL}record/medical-note-save-amendment`,
            params
        ).then(res => {
            if (res.data && res.data.response) {
                return res.data.response;
            }
            return [];
        });
    },
    async getSoapSection(soapId) {
        return Axios.get(
            `${baseURL}record/medical-note-template/${soapId}`
        ).then(res => {
            if (res.data && res.data.response) {
                return res.data.response;
            }
            return [];
        });
    },
    postSoapSection(soapId, params) {
        return Axios.post(
            `${baseURL}record/medical-note-template/${soapId}`,
            params
        ).then(res => {
            if (res.data && res.data.response) {
                return res.data.response;
            }
            return [];
        });
    },
    getDocumentsCountSoap(soapId) {
        return Axios.get(
            `${baseURL}record/medical-note-count-documents/${soapId}`
        ).then(res => {
            if (res.data && res.data.response) {
                return res.data.response;
            }
            return [];
        });
    },
    getSoapStatus(soapId) {
        return Axios.get(`${baseURL}record/medical-note-status/${soapId}`).then(
            res => {
                if (res.data && res.data.response) {
                    return res.data.response;
                }
                return null;
            }
        );
    }
};
